var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxtPayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.463,
    height: 42.445,
    viewBox: "0 0 42.463 42.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11906",
    "data-name": "Group 11906",
    transform: "translate(-940 -117.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37924",
    "data-name": "Path 37924",
    d: "M42.315,2H22.508a2.129,2.129,0,0,0-2.122,2.122V14.4a11.319,11.319,0,1,0,0,17.643V42.322a2.129,2.129,0,0,0,2.122,2.122H42.315a2.129,2.129,0,0,0,2.122-2.122V4.122A2.129,2.129,0,0,0,42.315,2ZM39.287,3.415,38.934,4.83H25.889l-.354-1.415ZM13.311,33.126a9.9,9.9,0,1,1,9.9-9.9,9.9,9.9,0,0,1-9.9,9.9Zm29.711,9.2a.707.707,0,0,1-.707.707H22.508a.707.707,0,0,1-.707-.707V30.686a11.257,11.257,0,0,0,0-14.926V4.122a.707.707,0,0,1,.707-.707h1.57l.573,2.292a.707.707,0,0,0,.686.538H39.485a.707.707,0,0,0,.686-.538l.573-2.292h1.57a.707.707,0,0,1,.707.707Z",
    transform: "translate(938.025 115.778)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37925",
    "data-name": "Path 37925",
    d: "M18.855,4.122h-9.2V2.707A.707.707,0,0,0,8.5,2.162L4.254,5.7a.707.707,0,0,0,0,1.089L8.5,10.326a.707.707,0,0,0,.453.163.724.724,0,0,0,.3-.064.707.707,0,0,0,.41-.644V8.366h9.2a.707.707,0,0,0,.707-.707V4.829A.707.707,0,0,0,18.855,4.122Zm-.707,2.83h-9.2a.707.707,0,0,0-.707.707v.615L5.81,6.244l2.433-2.03v.615a.707.707,0,0,0,.707.707h9.2Z",
    transform: "translate(937.434 115.779)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37926",
    "data-name": "Path 37926",
    d: "M19.308,53.7l-4.244-3.537a.707.707,0,0,0-1.16.545v1.415h-9.2A.707.707,0,0,0,4,52.829v2.83a.707.707,0,0,0,.707.707h9.2v1.415a.707.707,0,0,0,.41.644.724.724,0,0,0,.3.064.707.707,0,0,0,.453-.163l4.244-3.537a.707.707,0,0,0,0-1.089Zm-3.99,2.575v-.615a.707.707,0,0,0-.707-.707h-9.2V53.537h9.2a.707.707,0,0,0,.707-.707v-.615l2.433,2.03Z",
    transform: "translate(937.433 101.735)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37927",
    "data-name": "Path 37927",
    d: "M16.83,25.83a1.415,1.415,0,0,1,1.415,1.415h1.415a2.83,2.83,0,0,0-2.122-2.729V23H16.122v1.515a2.824,2.824,0,0,0,.707,5.559,1.415,1.415,0,1,1-1.415,1.415H14a2.83,2.83,0,0,0,2.122,2.729v1.515h1.415V34.218a2.824,2.824,0,0,0-.707-5.559,1.415,1.415,0,0,1,0-2.83Z",
    transform: "translate(934.507 109.634)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37928",
    "data-name": "Path 37928",
    d: "M8.488,23.515a8.5,8.5,0,0,0,0,12l1-1a7.082,7.082,0,0,1,0-10Z",
    transform: "translate(936.846 109.483)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37929",
    "data-name": "Path 37929",
    d: "M26.071,23.515l-1,1a7.082,7.082,0,0,1,0,10l1,1a8.5,8.5,0,0,0,0-12Z",
    transform: "translate(931.268 109.483)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37930",
    "data-name": "Path 37930",
    d: "M47.89,25.18l-4.952-2.122a.712.712,0,0,0-.557,0L37.429,25.18a.707.707,0,0,0-.429.65v2.487a4.922,4.922,0,0,0,1.45,3.5l3.709,3.708a.707.707,0,0,0,1,0l3.709-3.708a4.922,4.922,0,0,0,1.45-3.5V25.83a.707.707,0,0,0-.429-.65ZM46.9,28.316a3.518,3.518,0,0,1-1.036,2.5l-3.209,3.208-3.208-3.208a3.516,3.516,0,0,1-1.036-2.5V26.3l4.244-1.819L46.9,26.3Z",
    transform: "translate(927.777 109.634)",
    fill: "#2179fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37931",
    "data-name": "Path 37931",
    d: "M43.293,29.708l-1,1,1.415,1.415a.707.707,0,0,0,1,0l2.83-2.83-1-1-2.33,2.33Z",
    transform: "translate(926.229 108.085)",
    fill: "#2179fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtPayIcon);
export default __webpack_public_path__ + "static/media/Txt-Pay-Icon.bfc491cb.svg";
export { ForwardRef as ReactComponent };